/**
 * System Entities UI Components
 *
 * Provides three variants of UI components for rendering system entities:
 * - nano-ui: Small, square avatar-based components for tight spaces
 * - inline-ui: Badge-based components for inline display
 * - preview-ui: Card-based components for hover previews and detailed views
 *
 * Each variant includes a fallback component that handles unmapped entity types.
 * Entity-specific renderers can be added to each variant's renderer map over time.
 */

export { SystemEntityNano } from './nano-ui';
export { SystemEntityInline } from './inline-ui';
export { SystemEntityPreview } from './preview-ui';
export {
  systemEntityIcons,
  systemEntityDisplayNames,
  getEntityIcon,
  getEntityDisplayName,
} from './utils/index';
